"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _gbp = _interopRequireDefault(require("gbp"));
var _occasion = _interopRequireDefault(require("occasion"));
var _table = _interopRequireDefault(require("../../../core/table"));
var _link = _interopRequireDefault(require("../../../core/link"));
var _feesSummary = _interopRequireWildcard(require("../../competitions/finance/summary/fees-summary"));
var _constants = require("../../../../stripe/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function estimateStripeFees(amount) {
  return Math.round(amount * _constants.stripePercentage / 100 + _constants.stripeFixed);
}
function summariseTransactionFees(payments, charges) {
  let feesRefunded = 0;
  let feesPaid = 0;
  let feesPending = 0;
  let estStripeFees = 0;
  payments.map(payment => {
    // if payment has not yet been associated with a charge then estimate
    // fees based
    // on payment being equivalent to an individual charge
    // Note earlier payments did not have a charge so will use actuals on paid
    // record instead, this is less accurate as we assume a fixed stripe
    // fee per payment and don't allow for them being grouped to a single charge.
    if (!payment.chargeID) {
      if (payment.paymentStatusRef === 'CANC') {
        feesRefunded += payment.expectedTransactionFee;
      } else if (payment.paymentStatusRef === 'PAID' && payment.paidAmount) {
        feesPaid += payment.transactionFee;
        estStripeFees += estimateStripeFees(payment.paidAmount);
      } else {
        feesPending += payment.expectedTransactionFee;
        estStripeFees += estimateStripeFees(payment.expectedAmount);
      }
    }
  });
  charges.map(charge => {
    feesPaid += charge.chargeTransactionFee;
    estStripeFees += estimateStripeFees(charge.chargeAmount);
  });

  // const feesExpected = feesPaid + feesPending;
  return {
    feesRefunded,
    feesPaid,
    feesPending,
    estStripeFees
  };
}
const today = new Date().toISOString().split('T')[0];
var _ref = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", {
  key: "head1"
}, /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: 2
}, "Start Date"), /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: 2
}, "Competition"), /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: 2
}, "Charge Date"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center cell-border-left",
  colSpan: 5
}, "Entry Fees"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center cell-border-left",
  colSpan: 4
}, "Transaction Fees"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center cell-border-left",
  colSpan: 3
}, "Estimated Stripe Fees"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right cell-border-left",
  rowSpan: 2
}, "Estimated Jepso Payout")), /*#__PURE__*/_react.default.createElement("tr", {
  key: "head2"
}, /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right cell-border-left"
}, "Received"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Refunded Before Charge"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Pending"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Total Refunds"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Expected Payout"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right cell-border-left"
}, "Refunded Before Charge"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Paid"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Pending"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Total Expected"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right cell-border-left"
}, "Charge Fee"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Connect Fee"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Total Expected")));
var _ref2 = /*#__PURE__*/_react.default.createElement("th", {
  colSpan: 3
}, "TOTALS");
class SummaryByCompetition extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_getRowStyle", comp => {
      if (comp.startDate <= today) return {
        backgroundColor: 'lightgray'
      };
      if (comp.paymentsChargeDate <= today) return {
        backgroundColor: 'lavenderblush'
      };
      return null;
    });
    _defineProperty(this, "_getCompLink", comp => {
      if (!comp.isPublished && !comp.isAdministratedByUser) return comp.competitionName;
      return /*#__PURE__*/_react.default.createElement(_link.default, {
        to: '/year/' + this.props.yearID + '/competition/' + comp.competitionSlug
      }, comp.competitionName);
    });
  }
  render() {
    const yearTotals = {
      paidToClub: 0,
      refundedBeforePaymentReceived: 0,
      paymentsPending: 0,
      refundedByClub: 0,
      expectedForClub: 0,
      feesRefunded: 0,
      feesPaid: 0,
      feesPending: 0,
      expectedFees: 0,
      estStripeFees: 0,
      stripeConnectFee: 0,
      totalStripe: 0,
      jespoPayout: 0
    };
    const competitions = this.props.competitions.map(comp => {
      const compTotals = (0, _feesSummary.summarisePayments)(comp.payments);
      const compFees = summariseTransactionFees(comp.payments, comp.charges);
      const expectedFees = compFees.feesPaid + compFees.feesPending;
      const stripeConnectFee = Math.round(compTotals.expectedForClub * _constants.stripeConnectPecentage / 100);
      const totalStripe = compFees.estStripeFees + stripeConnectFee;
      const jespoPayout = compFees.feesPaid + compFees.feesPending - compFees.estStripeFees - stripeConnectFee;
      yearTotals.paidToClub += compTotals.paidToClub;
      yearTotals.refundedBeforePaymentReceived += compTotals.refundedBeforePaymentReceived;
      yearTotals.paymentsPending += compTotals.paymentsPending;
      yearTotals.refundedByClub += compTotals.refundedByClub;
      yearTotals.expectedForClub += compTotals.expectedForClub;
      yearTotals.feesRefunded += compFees.feesRefunded;
      yearTotals.feesPaid += compFees.feesPaid;
      yearTotals.feesPending += compFees.feesPending;
      yearTotals.expectedFees += expectedFees;
      yearTotals.estStripeFees += compFees.estStripeFees;
      yearTotals.stripeConnectFee += stripeConnectFee;
      yearTotals.totalStripe += totalStripe;
      yearTotals.jespoPayout += jespoPayout;
      return {
        startDate: comp.startDate,
        compLink: this._getCompLink(comp),
        paymentsChargeDate: comp.paymentsChargeDate,
        ...compTotals,
        ...compFees,
        expectedFees,
        stripeConnectFee,
        totalStripe,
        jespoPayout
      };
    });
    return /*#__PURE__*/_react.default.createElement(_table.default, null, _ref, /*#__PURE__*/_react.default.createElement("tbody", null, competitions.map(comp => /*#__PURE__*/_react.default.createElement("tr", {
      key: comp.id,
      style: this._getRowStyle(comp)
    }, /*#__PURE__*/_react.default.createElement("td", null, (0, _occasion.default)(comp.startDate, 'D MMM')), /*#__PURE__*/_react.default.createElement("td", null, comp.compLink), /*#__PURE__*/_react.default.createElement("td", null, (0, _occasion.default)(comp.paymentsChargeDate, 'D MMM')), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right cell-border-left"
    }, (0, _gbp.default)(comp.paidToClub)), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, (0, _gbp.default)(comp.refundedBeforePaymentReceived)), /*#__PURE__*/_react.default.createElement("td", {
      className: 'text-xs-right' + (comp.paidToClub && comp.paymentsPending ? ' text-danger' : '')
    }, (0, _gbp.default)(comp.paymentsPending)), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, '(' + (0, _gbp.default)(comp.refundedByClub) + ')'), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(comp.expectedForClub)), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right cell-border-left"
    }, (0, _gbp.default)(comp.feesRefunded)), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, (0, _gbp.default)(comp.feesPaid)), /*#__PURE__*/_react.default.createElement("td", {
      className: 'text-xs-right' + (comp.feesPaid && comp.feesPending ? ' text-danger' : '')
    }, (0, _gbp.default)(comp.feesPending)), /*#__PURE__*/_react.default.createElement("th", {
      className: 'text-xs-right'
    }, (0, _gbp.default)(comp.expectedFees)), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right cell-border-left"
    }, (0, _gbp.default)(comp.estStripeFees)), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, (0, _gbp.default)(comp.stripeConnectFee)), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(comp.totalStripe)), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right cell-border-left"
    }, (0, _gbp.default)(comp.jespoPayout))))), /*#__PURE__*/_react.default.createElement("tfoot", null, /*#__PURE__*/_react.default.createElement("tr", {
      key: "foot"
    }, _ref2, /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right cell-border-left"
    }, (0, _gbp.default)(yearTotals.paidToClub)), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(yearTotals.refundedBeforePaymentReceived)), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(yearTotals.paymentsPending)), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, '(' + (0, _gbp.default)(yearTotals.refundedByClub) + ')'), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(yearTotals.expectedForClub)), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right cell-border-left"
    }, (0, _gbp.default)(yearTotals.feesRefunded)), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(yearTotals.feesPaid)), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(yearTotals.feesPending)), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(yearTotals.expectedFees)), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right cell-border-left"
    }, (0, _gbp.default)(yearTotals.estStripeFees)), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(yearTotals.stripeConnectFee)), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(yearTotals.totalStripe)), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right cell-border-left"
    }, (0, _gbp.default)(yearTotals.jespoPayout)))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref3 = _mergeBqlQueries({
  id: true,
  competitionName: true,
  competitionSlug: true,
  isPublished: true,
  isAdministratedByUser: true,
  isCancelled: true,
  startDate: true,
  paymentsChargeDate: true,
  payments: {
    expectedTransactionFee: true,
    transactionFee: true,
    paymentStatusRef: true,
    expectedAmount: true,
    paidAmount: true,
    chargeID: true
  },
  charges: {
    chargeAmount: true,
    chargeTransactionFee: true
  }
}, _feesSummary.default.partialQueries.Competition);
var _default = exports.default = (0, _reactBicycle.connect)(SummaryByCompetition, props => ({
  ["competitions(yearID:" + JSON.stringify(+props.yearID) + ")"]: _ref3
}));